/* Dropdown listant les copies rendues d'un devoir (URLs signées), avec */
/* affichage plein écran (lightbox) au clic. Chargement paresseux à l'ouverture. */

import { useState } from 'react';
import { Alert } from '@/components/ui/alert';
import { api } from '../lib/api';

interface Asset {
  id: string;
  url: string;
  content_type: string;
}

export default function SubmittedAssets({ studentId, assignmentId }: { studentId: string; assignmentId: string }) {
  const [open, setOpen] = useState(false);
  const [assets, setAssets] = useState<Asset[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [zoom, setZoom] = useState<string | null>(null);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && assets === null) {
      setLoading(true);
      setError(null);
      try {
        const r = await api.parentOrTutor.student.submissionAssets.query({ studentId, assignmentId });
        setAssets(r as Asset[]);
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="w-full mt-2">
      <button type="button" className="inline-flex items-center gap-[6px] min-h-[40px] px-1 border-none bg-transparent text-muted-foreground text-[13px] font-semibold cursor-pointer" onClick={() => void toggle()} aria-expanded={open}>
        {open ? '▾' : '▸'} Copies rendues{assets ? ` (${assets.length})` : ''}
      </button>

      {open && (
        <>
          {loading && <p className="text-muted-foreground text-[13px] my-[6px]">Chargement…</p>}
          {error && <Alert>{error}</Alert>}
          {assets && assets.length === 0 && !loading && <p className="text-muted-foreground text-[13px] my-[6px]">Aucune copie.</p>}
          {assets && assets.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-2">
              {assets.map((a, i) => (
                <img
                  key={a.id}
                  className="w-[72px] h-[72px] object-cover rounded-[8px] border border-border cursor-pointer"
                  src={a.url}
                  alt={`Copie ${i + 1}`}
                  onClick={() => setZoom(a.url)}
                />
              ))}
            </div>
          )}
        </>
      )}

      {zoom && (
        <div className="fixed inset-0 z-[1200] flex items-center justify-center p-4 bg-[rgba(11,42,74,0.8)]" role="dialog" aria-modal="true" onClick={() => setZoom(null)}>
          <button type="button" className="absolute top-[calc(env(safe-area-inset-top)+12px)] right-4 min-w-[44px] min-h-[44px] border-none rounded-full bg-[rgba(255,255,255,0.9)] text-[#0b2a4a] text-[24px] leading-none cursor-pointer" onClick={() => setZoom(null)} aria-label="Fermer">
            ×
          </button>
          <img className="max-w-full max-h-full rounded-[8px] shadow-card" src={zoom} alt="Copie rendue" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
